export enum CatchUpPurpose {
    RESUME = 0,
    LATE_BUYER = 1,
}
